import { AnyAction } from '@reduxjs/toolkit'

import { FETCH_CONVERSATION_ANALYTICS_SUCCESS, FETCH_CONVERSATION_LOGS_SUCCESS } from './actionTypes'

type Metrics = {
  conversationLog: unknown
  activityHistory: unknown[]
  activityCount: unknown[]
  topTopics: unknown[]
}

type SpaceChatbotAnalyticsPageState = {
  metrics: Metrics
  searchedUsers: string[]
  conversations?: unknown
}

const initialState: SpaceChatbotAnalyticsPageState = {
  metrics: {
    conversationLog: {},
    activityHistory: [],
    activityCount: [],
    topTopics: []
  },
  searchedUsers: []
}

export default function conversationAnalytics(state = initialState, action: AnyAction): SpaceChatbotAnalyticsPageState {
  switch (action.type) {
    case FETCH_CONVERSATION_ANALYTICS_SUCCESS: {
      const metrics = {} as Metrics
      action.response.forEach((metric: any) => {
        const METRIC_NAME = Object.entries(metric)[0][0]
        const METRIC_RESULTS = Object.entries(metric)[0][1]
        // @ts-expect-error
        metrics[METRIC_NAME] = METRIC_RESULTS
      })
      return {
        ...state,
        metrics: { ...metrics }
      }
    }
    case FETCH_CONVERSATION_LOGS_SUCCESS: {
      return {
        ...state,
        conversations: action.response.results
      }
    }
    default: {
      return state
    }
  }
}
